import React, { useState } from 'react';
import { Button, Select } from 'antd';
import ApphomeFilter from '../ApphomeFilter';
import { withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { updatePage } from '../ApphomeActions';
import axios from 'axios';
import { useEffect } from 'react';
import AppHomeFilterV2 from '../AppHomeFilterV2';
const { Option } = Select;
const CustomizeData = (props) => {
  const wId = props.match.params.wId;
  const apphome = useSelector((state) => state.apphome.apphome);
  const isPersonalApphome = apphome.isWorkspaceApphome ? false : true;
  const isDarkTheme = localStorage.getItem('theme') == 'dark' ? true : false;

  const pageInfo =
    apphome &&
    apphome.pages &&
    apphome.pages.find((page) => page._id === (apphome && apphome.pageView));
  const pageViewType = pageInfo && pageInfo.pageViewType;
  const dispatch = useDispatch();
  const [filterType, setFilterType] = useState('prebuiltfilter');
  const [preBuiltFilter, setPreBuiltFilter] = useState(
    pageViewType === 'issues' ? 'assigned_to_me' : 'tickets_by_status'
  );
  const [customFilters, setCustomFilters] = useState([]);
  const [jqlFilter, setJqlFilter] = useState('');
  const [selectedFilterFromJira, setSelectedFilterFromJira] = useState('');
  const [errors, setErrors] = useState({});
  const [issuesPerPage, setIssuesPerPage] = useState('10');
  const [requestTypeFilter, setRequestTypeFilter] = useState('');
  const [requestTypeProjectInfo, setRequestTypeProjectInfo] = useState({});
  const [updateNow, setUpdateNow] = useState(false);
  const [defaultFilterName, setDefaultFilterName] = useState('');
  const [defaultFilterKey, setDefaultFilterKey] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const validateButtons = async () => {
    try {
      const errorsObj = {};

      if (filterType === 'customfilter') {
      } else if (filterType === 'jqlfilter') {
        if (!jqlFilter) {
          errorsObj.jqlFilter = 'Jql is required';
        } else {
          const response = await axios.post(
            `/bot/api/w/${props.match.params.wId}/jira/verifyJql`,
            { jql: jqlFilter }
          );
          if (response.data.success == false) {
            errorsObj.jqlFilter =
              response.data.error && response.data.error.message
                ? response.data.error.message
                : 'Invalid JQL';
          }
        }
      } else if (filterType === 'filterfromjira') {
        if (!selectedFilterFromJira) {
          errorsObj.selectedFilterFromJira = '* Pleas select a filter';
        }
      }

      setErrors(errorsObj);
      return Object.keys(errorsObj).length > 0 ? false : true;
    } catch (error) {
      // console.log(error);
    }

    // return Object.keys(errorsObj).length > 0;
  };
  const handleSave = async () => {
    const isValid = await validateButtons();
    if (isValid) {
      let data = {
        customizeConfiguration: {
          issuesPerPage,
          filterType,
          preBuiltFilter,
          customFilters,
          jqlFilter,
          selectedFilterFromJira,
          requestTypeFilter,
          requestTypeProjectInfo,
          defaultFilterName,
          defaultFilterKey,
        },
      };

      await dispatch(
        updatePage(props.match.params.wId, apphome._id, apphome.pageView, data)
      );
      // if (isPersonalApphome) {
      //   props.history.push(
      //     `/${props.match.params.wId}/settings/personalapphome`
      //   );
      // } else {
      //   props.history.push(`/${props.match.params.wId}/slackApp?view=appHome`);
      // }
    }
  };

  useEffect(() => {
    if (apphome && apphome._id) {
      const page = apphome.pages.find((page) => page._id === apphome.pageView);
      const customizeConfiguration = page.customizeConfiguration;
      setFilterType(customizeConfiguration.filterType);
      setPreBuiltFilter(customizeConfiguration.preBuiltFilter);
      setCustomFilters(customizeConfiguration.customFilters);
      setJqlFilter(customizeConfiguration.jqlFilter);
      setIssuesPerPage(customizeConfiguration.issuesPerPage);
      setSelectedFilterFromJira(customizeConfiguration.selectedFilterFromJira);
      setRequestTypeFilter(customizeConfiguration.requestTypeFilter);
      setRequestTypeProjectInfo(customizeConfiguration.requestTypeProjectInfo);
      setDefaultFilterName(
        customizeConfiguration && customizeConfiguration.defaultFilterName
      );
      setDefaultFilterKey(
        customizeConfiguration && customizeConfiguration.defaultFilterKey
      );

      // fetchIsAdmin();
    }
  }, [apphome]);

  // for auto save

  // debounce to avoid calling save on each and every state change
  // const debounce = (func, delay) => {
  //   let timer;
  //   return function (...args) {
  //     clearTimeout(timer);
  //     timer = setTimeout(() => func.apply(this, args), delay);
  //   };
  // };

  // const debouncedHandleSave = debounce(handleSave, 500);

  // const fetchIsAdmin = async () => {
  //   let resp = await axios.get(
  //     `/api/w/${props.match.params.wId}/workspace/isAdmin`
  //   );
  //   setIsAdmin(resp.data.isAdmin);
  // };

  useEffect(() => {
    if (updateNow) {
      // debouncedHandleSave()
      handleSave();

      setUpdateNow(false);
    }
  }, [
    updateNow,
    // requestTypeFilter,
    // requestTypeProjectInfo,
  ]);

  return (
    <div
      className='apphome_create_button_container'
      style={{ background: `${isDarkTheme ? '' : '#fff'}` }}
    >
      <div className='apphome_create_button_container_child'>
        <div className='apphome_create_button_container_child_title'>
          {pageViewType === 'issues' ? 'Issues' : 'Requests'} per page
        </div>
        <div>
          <Select
            value={issuesPerPage}
            onChange={(value) => {
              setIssuesPerPage(value);
              setUpdateNow(true);
            }}
            style={{ width: '250px' }}
          >
            <Option value='5'>5</Option>
            <Option value='10'>10</Option>
            <Option value='20'>20</Option>
          </Select>
        </div>
      </div>
      {pageViewType === 'requests' && (
        <>
          <div className='apphome_create_button_container_child'>
            <ApphomeFilter
              findType={filterType}
              setFindType={setFilterType}
              apphome={apphome}
              preBuiltFilter={preBuiltFilter}
              setPreBuiltFilter={setPreBuiltFilter}
              customFilters={customFilters}
              setJqlFilter={setJqlFilter}
              jqlFilter={jqlFilter}
              setCustomFilters={setCustomFilters}
              selectedFilterFromJira={selectedFilterFromJira}
              setSelectedFilterFromJira={setSelectedFilterFromJira}
              errors={errors}
              requestTypeFilter={requestTypeFilter}
              setRequestTypeFilter={setRequestTypeFilter}
              requestTypeProjectInfo={requestTypeProjectInfo}
              setRequestTypeProjectInfo={setRequestTypeProjectInfo}
            />
          </div>
          <div>
            <Button type='primary' onClick={handleSave}>
              Save
            </Button>
          </div>
        </>
      )}
      {pageViewType === 'issues' && (
        <AppHomeFilterV2
          IssuesPerPage={issuesPerPage}
          setIssuesPerPage={setIssuesPerPage}
          appHomeInfo={apphome}
          setFilterType={setFilterType}
          filterType={filterType}
          setJqlFilter={setJqlFilter}
          jqlFilter={jqlFilter}
          preBuiltFilter={preBuiltFilter}
          setPreBuiltFilter={setPreBuiltFilter}
          selectedFilterFromJira={selectedFilterFromJira}
          setSelectedFilterFromJira={setSelectedFilterFromJira}
          updateNow={updateNow}
          setUpdateNow={setUpdateNow}
          defaultFilterName={defaultFilterName}
          setDefaultFilterName={setDefaultFilterName}
          defaultFilterKey={defaultFilterKey}
          setDefaultFilterKey={setDefaultFilterKey}
          isPersonalApphome={isPersonalApphome}
        />
      )}
    </div>
  );
};

export default withRouter(CustomizeData);
